import { useContext } from "react";

import { DesktopBridgeRoomContext } from "./desktop-bridge-room.context.js";

export const useDesktopBridgeRoom = (): string => {
  const context = useContext(DesktopBridgeRoomContext);

  if (!context.__ctx_init) {
    throw new Error(
      "useDesktopBridgeRoom must be used within a DesktopBridgeRoomProvider"
    );
  }

  return context.room;
};
